import React, { Component } from 'react';
import RequestApi from '../../Miscelania/RequestApi';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';




// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import AlertaInline from '../../Miscelania/AlertaInline';

const PropTypes = require('prop-types');

class ExamAcoes extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      exam_date: '',
      hora_inicial: '',
      hora_final: '',
      message_justification: '',
      modal: false,
      dados: [],
      lista_instrutores: [],
      lista_provas: [],
      questao: {},
      questoes: {},
      opcoes: [],
      questao_selecionada: 'undefined',
      message_contest: '',
      carregando_prova: 0,
      validate: 0,
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);
    this.trocarActive = this.trocarActive.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.downloadExam = this.downloadExam.bind(this);
    this.export = this.export.bind(this);
    this.justificar = this.justificar.bind(this);
    this.validar = this.validar.bind(this);
    this.recarregarQuestoes = this.recarregarQuestoes.bind(this);
    this.refreshAll = this.refreshAll.bind(this);
  }
  
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 
  componentDidMount () {
    this.refs.request_api.verifyPermission();
  }

  trocarActive () {
    var datasave = {
      id: this.props.dadosProva.id,
      active: 0,
    };
    var confirmacao = window.confirm('Tem certeza que deseja arquivar essa prova?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/change_active', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.refreshTable(responseJson);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  questaoSelecionada (questao_selecionada) {
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });
  }

  buscarQuestoes () {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  downloadExam () {
    var url = config.get('api') + '/download/prova/finalizada/' + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  export() {
    var self = this;
    var url = "/exportar/resultado/prova/" + this.props.dadosProva.id;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }


  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.state.questoes[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({
        questao: questao,
        opcoes: opcoes,
        message_justification: '',
      });
    }
  }
  
  justificar(value) {
    var dados = {
      'question_id': value,
      'justification': this.state.message_justification,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de justificar essa questão sem valida-la?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/justificar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.recarregarQuestoes(responseJson);
        }).catch((error) => {
          return error;
        });
      });
    }
  }

  validar(value) {
    var dados = {
      'question_id': value,
      'justification': this.state.message_justification,
      'questions': this.state.questoes,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de validar essa questão?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/validar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.refreshAll(responseJson);
        }).catch((error) => {
          return error;
        });
      });
    }
  }
  
  refreshAll (event) {
    var self = this;
    var header = this.recarregarQuestoes(event);
    Promise.resolve(header).then(function(value) {
      //self.props.recarregarProvas();
    });
  }
  recarregarQuestoes (event) {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: event.message});
          self.setState({tipo_alerta: event.status});
          self.questaoSelecionada(self.state.questaoSelecionada);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  {!this.props.onlyExport ? <button onClick={this.trocarActive} className='btn btn-xs btn-success' alt='Trocar para arquivado' title="Trocar para arquivado"><i className="fa fa-fw fa-power-off"></i></button> : ""}
  {!this.props.onlyExport ? <button onClick={this.downloadExam} className='btn btn-success btn-xs'><i className="fa fa-fw fa-download" alt='Download de prova' title="Download de prova"></i></button> : ""}
  <button onClick={this.export} className='btn btn-default btn-xs'><i className="fa fa-fw fa-file-pdf-o" alt='Resultado de prova' title="Resultado de prova"></i></button>
</div>
    );
  }
}

ExamAcoes.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamAcoes;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamAcoes.js